module.exports = __webpack_public_path__ + "static/media/icono-xpdconnect-blanco.2c82ff42.svg";